<template>
    <v-app>     
       <dashboard-Core-App-Bar />
      <dashboard-core-drawer />
      <dashboard-core-view />
      <dashboard-core-settings />
    </v-app>  
  </template>
  
  <script>
  export default {
    name: "DashboardIndex",
    components: {   
      DashboardCoreAppBar: () => import("./components/userEtc/AppBar"),
      DashboardCoreDrawer: () => import("./components/userEtc/Drawer"), 
      DashboardCoreSettings: () => import("./components/userEtc/Settings"),
      DashboardCoreView: () => import("./components/userEtc/View"),
    },
    data: () => ({   
      loginuser: JSON.parse(localStorage.getItem('user')) || 0,   
    }),
      mounted() {
        let user = JSON.parse(localStorage.getItem('user')) || 0
        if (user.personnel_etc_m_type == 'governmentteach' || user.personnel_etc_m_type == 'governmentsp' || user.personnel_etc_m_type == 'temporary' || user.personnel_etc_m_type == 'temporary_job')
        {
        
        }else{
              this.$router.push('/')           
        }
          
      },
          methods: {        
        home() {
          this.$router.push('user')
        },
        logout() {
          localStorage.clear()
          this.$router.push('/')
        }
      }
  };
  </script>
  <style>
  .text_google {
    font-family: "Kanit", sans-serif;
  }
  .v-data-table thead th {
    font-size: 16px !important;
  }
  </style>
  